import dayjs from 'dayjs';

import { Text } from '@highlight-cp/core-ui';

interface DateTimeCellProps {
  dateString: string | undefined;
}

/**
 * ### DateTimeCell
 *
 * @description
 * Custom date cell component that displays both date and time
 *
 * @example
 * <DateTimeCell dateString="2023-12-25T10:30:00Z" />
 *
 * @param props - Component props
 * @returns React component
 */
export const DateTimeCell = ({ dateString }: DateTimeCellProps) => {
  if (!dateString) return <Text>-</Text>;

  return (
    <Text component="span" title={dateString}>
      {dayjs(dateString).format('MMM DD YYYY h:mm A')}
    </Text>
  );
};
